import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Autoplay, Thumbs } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/thumbs'
import 'swiper/css/effect-fade'
import designServices from '../assets/images/projects/birembo/1.jpg'
import realEstate from '../assets/images/projects/kanombe/Kanombe5.jpg'
import constructionServices from '../assets/images/projects/birembo/2.jpg'
import landSurveying from '../assets/images/projects/kanombe/Kanombe7.jpg'
import '../css/main.css'

const slides = [
  {
    image: designServices,
    title: 'Architecture Design',
    description:
      'Creative architectural designs that shape the future. We offer tailored design solutions combining innovation, sustainability, and functionality to meet each client’s unique vision and needs.'
  },
  {
    image: constructionServices,
    title: 'Construction',
    description:
      'Building durable, high-quality structures from the ground up. Our expert construction team ensures precision, efficiency, and safety throughout the project lifecycle, delivering lasting results.'
  },
  {
    image: landSurveying,
    title: 'Interior Design',
    description:
      'Transforming spaces with innovative interior design solutions. Our team creates functional and aesthetically pleasing environments that reflect each client’s unique style and needs.'
  },
  {
    image: realEstate,
    title: 'Real Estate',
    description:
      'Connecting people with their dream properties and investments. Whether buying, selling, or leasing, our real estate experts offer guidance, transparency, and market insight for smart decision-making.'
  }
]

function HeroSlider() {
  const [thumbsSwiper, setThumbsSwiper] = useState(null)

  return (
    <div className="min-h-screen relative overflow-hidden">
      {/* Main Swiper */}
      <Swiper
        modules={[Autoplay, Thumbs]}
        autoplay={{ delay: 5000, disableOnInteraction: false }}
        loop={true}
        thumbs={{ swiper: thumbsSwiper }}
        className="min-h-screen"
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div
              className="w-screen min-h-screen bg-cover bg-center bg-no-repeat relative"
              style={{ backgroundImage: `url(${slide.image})` }}
            >
            <div className="absolute bottom-1/4 left-8 md:left-16 z-10 max-w-md">
              <div className="bg-black/40 backdrop-blur-sm p-6 md:p-8 rounded-xl">
                <h1 className="text-xl md:text-2xl font-bold mb-3 bg-gradient-to-r from-white to-teal-200 bg-clip-text text-transparent">
                  {slide.title}
                </h1>

                <p className="text-sm md:text-base leading-relaxed font-light mb-5 text-white">
                  {slide.description}
                </p>

                <button className="inline-flex text-sm items-center text-white bg-primary-dark px-5 py-3 rounded-md  shadow-lg hover:bg-primary-light transition">
                  More Projects
                  <i className="fa fa-angle-double-right ml-2" />
                </button>
              </div>
            </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Thumbnails Swiper */}
      <div className="absolute bottom-6 left-0 right-0 z-20 px-4">
        <Swiper
          onSwiper={setThumbsSwiper}
          spaceBetween={10}
          slidesPerView={4}
          watchSlidesProgress
          className="max-w-4xl mx-auto"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={`thumb-${index}`}>
              <img
                src={slide.image}
                alt={slide.title}
                className="w-full h-24 object-cover cursor-pointer rounded-md border-2 border-transparent hover:border-white transition"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}

export default HeroSlider
